import CheckList from '../../../src/components/common/icons/CheckList' // Assuming correct path
import LayerIcon from '../../components/common/icons/LayerIcon'
import PeopleIcon from '../../components/common/icons/PeopleIcon'
import SuiteCasePending from '../../components/common/icons/SuiteCasePending'

export const statsData = [
  {
    id: 1,
    icon: CheckList,
    value: '120+',
    label: 'Programs',
    label_ml: 'പ്രോഗ്രാമുകൾ',
  },
  {
    id: 2,
    icon: SuiteCasePending,
    value: '26000+',
    label: 'Man Days',
    label_ml: 'മാൻ ഡേസ്',
  },
  {
    id: 3,
    icon: PeopleIcon,
    value: '9000+',
    label: 'Participants',
    label_ml: 'പങ്കെടുത്തവർ',
  },
  {
    id: 4,
    icon: LayerIcon,
    value: '6+',
    label: 'Initiatives',
    label_ml: 'പ്രവർത്തനങ്ങൾ',
  },
]
